import React, { useState } from 'react';
import './FAQ.css';

const FAQ = ({ faqs = [] }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const defaultFAQs = [
    {
      question: 'Is the app available for free?',
      answer: 'Yes. The app is free to download. All the Smartphone diagnostic tests and battery deterioration test are free to use.'
    },
    {
      question: 'Can I also use Battery Prediction Diagnostics?',
      answer: 'Yes, you can use Battery Prediction Diagnostics in PhoneVue. This feature allows you to diagnose your battery status from the current remaining battery level and predict battery deterioration. The app automatically creates a graph by repeating the diagnosis, and you can view results such as "Very good", "Normal", or "Very bad" in the Report section.'
    },
    {
      question: 'Where can I check the diagnosis results?',
      answer: 'You can check all your diagnosis results in the Report section of the PhoneVue app. After running any diagnostic test, including battery deterioration tests, the results are displayed instantly in the Report section. You can also view your complete test history if you have registered with a simple login.'
    },
    {
      question: 'Is profile registration required?',
      answer: 'Profile registration is not required to use basic diagnostic tests. However, if you want to save your test history and securely record all your smartphone diagnostic test results, you will need to register with a simple login. Registration is necessary for the first diagnosis if you want to use the User Type Deterioration feature.'
    },
    {
      question: 'There is a button to start the camera and read the barcode in the IMEI input part of the initial setting screen. How can I use it?',
      answer: 'The barcode scanner feature allows you to quickly input your device IMEI number. Simply tap the camera button next to the IMEI input field on the initial setting screen, point your camera at the barcode (usually found on your device box or in device settings), and the app will automatically read and fill in the IMEI number for you.'
    },
    {
      question: 'If "Fail" comes out in the diagnosis result, will the smartphone break down immediately?',
      answer: 'No, a "Fail" result in the diagnosis does not mean your smartphone will break down immediately. A "Fail" result indicates that a particular component or function is not working properly or is outside normal parameters. It is a warning that you should pay attention to that specific issue. You should consider getting the device checked by a professional technician, but it does not mean immediate failure.'
    }
  ];

  const faqList = faqs.length > 0 ? faqs : defaultFAQs;

  return (
    <div className="faq-container">
      <div className="faq-header">
        <p className="faq-label">FAQ</p>
        <h2 className="faq-title">Have Questions? Look Here</h2>
      </div>
      <div className="faq-list">
        {faqList.map((faq, index) => (
          <div key={index} className={`faq-item ${openIndex === index ? 'open' : ''}`}>
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
            >
              <span className="faq-question-text">
                <span className="faq-number">{index + 1}.</span> {faq.question}
              </span>
              <span className="faq-icon">{openIndex === index ? '▲' : '▼'}</span>
            </button>
            <div className={`faq-answer ${openIndex === index ? 'open' : ''}`}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;

